import { render, staticRenderFns } from "./ProjectBriefingCreate.vue?vue&type=template&id=c43d05bc"
import script from "./ProjectBriefingCreate.vue?vue&type=script&lang=js"
export * from "./ProjectBriefingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports